module.exports = __webpack_public_path__ + "static/media/delete-icon.0f05bef8.png";